/**
 * The two looks of a premise's announcement. They behave the same and differ only in style: `callout` is a card in
 * the content (the public page), `bar` a full-width strip (the editor's preview, the top of a premise's own site).
 */
export type AnnouncementVariant = 'callout' | 'bar'

/**
 * The look an element's `variant` attribute asks for. A premise types it by hand on its own site, so anything
 * unrecognised (a typo, a later value this build does not know yet) falls back to the callout rather than breaking.
 */
export function toAnnouncementVariant(value: string | null | undefined): AnnouncementVariant {
  return value?.trim().toLowerCase() === 'bar' ? 'bar' : 'callout'
}

/**
 * Whether the announcement has rich text worth a "Zobraziť viac". The editor leaves markup with nothing visible in it
 * (`<p><br></p>`, a lone `&nbsp;`), which must not produce a button that opens onto nothing. An image counts as
 * content.
 */
export function hasRichText(html: string): boolean {
  if (/<img\b/i.test(html)) return true
  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;|&#xa0;/gi, ' ')
    .trim()
  return text.length > 0
}
